var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"pageloader is-active"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.loaderContent))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }